import get from 'lodash/get';

import {
  FETCH_MARKET_LOCATIONS,
  LOCATIONS_LOADING,
} from '../actions/locations';
import { LOC_OPEN } from '../lib/utils';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_MARKET_LOCATIONS: {
      const marketLocations = get(action, 'payload', []);
      const activeMarketLocations = marketLocations.filter(
        (location) => location.status === LOC_OPEN,
      );
      const activeMarketWarehouseLocations = marketLocations.filter(
        (location) => location.status === LOC_OPEN && location.isWarehouse === true,
      );
      return {
        ...state,
        marketLocations,
        activeMarketLocations,
        activeMarketWarehouseLocations,
      };
    }
    case LOCATIONS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    default:
      return state;
  }
}
